module.exports = __webpack_public_path__ + "img/Boy_030032.276a0fc1.png";